import React from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  Box,
  IconButton,
  CircularProgress,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const WLCustomModal = ({
  title,
  btnText,
  btnDisabled,
  btnOnClick,
  btnColor = "primary",
  secondaryBtnText,
  secondaryBtnOnClick,
  visible,
  setVisible,
  width = "500px",
  children,
  noBtn = false,
  notCloseable = false,
  loading = false,
  background = "#fff",
}) => {
  const handleClose = () => setVisible(false);

  return (
    <Dialog
      open={visible}
      onClose={notCloseable ? undefined : handleClose}
      PaperProps={{
        sx: {
          borderRadius: "24px",
          overflow: "hidden",
          width: width,
          padding: 0,
          background: background,
          fontFamily: '"Nunito", "Inter", ui-sans-serif, system-ui, -apple-system, sans-serif',
          "& *": {
            fontFamily: '"Nunito", "Inter", ui-sans-serif, system-ui, -apple-system, sans-serif',
          },
        },
      }}
    >
      <DialogTitle
        sx={{
          fontWeight: 800,
          fontSize: "18px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "20px 24px",
          m: 0,
          color: "#1c1f2a",
        }}
      >
        {title}
        {!notCloseable && (
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              color: "#4a4f5e",
              background: "#f5f5f5",
              borderRadius: "50%",
              width: 36,
              height: 36,
              flexShrink: 0,
              "&:hover": { background: "#ebebeb" },
            }}
          >
            <CloseIcon style={{ fontSize: "16px" }} />
          </IconButton>
        )}
      </DialogTitle>

      <Divider />

      <Box sx={{ padding: "24px" }}>
        {loading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "200px",
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          children
        )}
      </Box>

      {!noBtn && (
        <>
          <Divider />
          <Box
            sx={{
              display: "flex",
              justifyContent: "end",
              gap: 2,
              padding: "14px 22px",
              background: "#faf8f4",
            }}
          >
            {secondaryBtnText && (
              <Button
                variant="outlined"
                onClick={secondaryBtnOnClick ?? handleClose}
                sx={{
                  textTransform: "none",
                  fontSize: "14px",
                  fontWeight: 700,
                  borderRadius: "50px",
                  px: "18px",
                  height: "44px",
                  borderColor: "#ece7dd",
                  color: "#4a4f5e",
                  "&:hover": { borderColor: "#aaa", background: "#f5f5f5" },
                }}
              >
                {secondaryBtnText}
              </Button>
            )}
            <Button
              variant="contained"
              color={btnColor}
              sx={{
                textTransform: "none",
                backgroundColor: "#2F4B9B",
                fontWeight: 600,
                fontSize: "14px",
                borderRadius: "50px",
                px: "22px",
                height: "44px",
              }}
              onClick={btnOnClick}
              disabled={btnDisabled}
            >
              {btnText}
            </Button>
          </Box>
        </>
      )}
    </Dialog>
  );
};

export default WLCustomModal;
